export default "__VITE_ASSET__DigYkaLU__"